(() => {
  if (window.OCStoreOffers) return;
  const seed = document.getElementById('oc-store-offers-data');
  if (!seed) return;
  const config = JSON.parse(seed.textContent);
  const tierIds = new Set(config.tierIds.map(String));
  const companionIds = new Set(config.companionIds.map(String));
  const triggerIds = new Set(config.triggerIds.map(String));
  const variants = new Map();
  let cart = config.cart;
  let refreshTimer, paintTimer, pending, revision = 0;
  const subtotal = items => items.reduce((n, x) => n + (tierIds.has(String(x.product_id)) ? x.original_price * x.quantity : 0), 0);
  const tier = total => total > 1500000 ? 15 : total >= 1000000 ? 10 : total >= 600000 ? 5 : 0;
  const money = n => new Intl.NumberFormat('en-PK', {style: 'currency', currency: config.currency, minimumFractionDigits: n % 100 ? 2 : 0, maximumFractionDigits: 2}).format(n / 100);
  function priceFor(variant, state = cart, now = Date.now()) {
    const items = state.items || [];
    const id = String(variant.productId);
    const base = Number(variant.price);
    let total = subtotal(items);
    let companionTotal = 0, qualifier = 0, hasTrigger = false;
    for (const item of items) {
      const productId = String(item.product_id);
      if (companionIds.has(productId)) companionTotal += item.original_price * item.quantity;
      if (triggerIds.has(productId)) { hasTrigger = true; qualifier = Math.max(qualifier, item.original_price); }
    }
    const alreadyQualifies = hasTrigger || tier(total) > 0;
    let candidateCompanion = companionIds.has(id);
    if (tierIds.has(id)) total += base;
    if (candidateCompanion) companionTotal += base;
    if (triggerIds.has(id)) {
      if (!hasTrigger || base > qualifier) candidateCompanion = false;
      hasTrigger = true;
      qualifier = Math.max(qualifier, base);
    }
    const basketPct = tier(total);
    const basketSaving = total * basketPct / 100;
    const companionSaving = hasTrigger && now < config.companionEndsAt ? (companionTotal - qualifier) * 0.1 : 0;
    let pct = 0;
    if (alreadyQualifies && !(state.discount_codes || []).some(x => x.applicable)) {
      if (companionSaving > basketSaving) pct = candidateCompanion ? 10 : 0;
      else if (tierIds.has(id)) pct = basketPct;
    }
    return {pct, price: base - Math.round(base * pct / 100), original: pct ? base : Math.max(base, Number(variant.compareAt) || 0)};
  }
  function variantFrom(node) {
    const id = String(node.dataset.offerPrice);
    const entry = {id, productId: node.dataset.offerProduct, price: Number(node.dataset.basePrice), compareAt: Number(node.dataset.comparePrice) || 0};
    if (!variants.has(id)) variants.set(id, entry);
    return variants.get(id);
  }
  function render(node) {
    const variant = variantFrom(node);
    const result = priceFor(variant);
    const caption = node.dataset.offerLabel || config.caption;
    const signature = [variant.id, result.pct, result.price, result.original, caption].join('|');
    if (node.dataset.offerRendered === signature && node.querySelector('b') && node.dataset.offerPct === String(result.pct)) return;
    node.dataset.offerRendered = signature;
    node.dataset.offerPct = result.pct;
    node.replaceChildren();
    if (result.original > result.price) { const old = document.createElement('s'); old.textContent = money(result.original); node.append(old); }
    const current = document.createElement('b'); current.textContent = money(result.price); node.append(current);
    if (result.pct) { const label = document.createElement('small'); label.textContent = result.pct + '% ' + caption; node.append(label); }
  }
  function quote(selection) {
    const chosen = selection.map(item => ({...variants.get(String(item.id)), quantity: item.quantity}));
    if (chosen.some(item => !item.productId)) return null;
    const items = cart.items || [];
    let total = subtotal(items), companionTotal = 0, existingQualifier = 0;
    for (const item of items) {
      const id = String(item.product_id);
      if (companionIds.has(id)) companionTotal += item.original_price * item.quantity;
      if (triggerIds.has(id)) existingQualifier = Math.max(existingQualifier, item.original_price);
    }
    let qualifier = existingQualifier;
    for (const item of chosen) {
      if (tierIds.has(String(item.productId))) total += item.price * item.quantity;
      if (companionIds.has(String(item.productId))) companionTotal += item.price * item.quantity;
      if (triggerIds.has(String(item.productId))) qualifier = Math.max(qualifier, item.price);
    }
    const pct = tier(total);
    const companionSaving = qualifier && Date.now() < config.companionEndsAt ? (companionTotal - qualifier) * 0.1 : 0;
    const useCompanion = companionSaving > total * pct / 100;
    let keepOne = qualifier > existingQualifier;
    return chosen.reduce((sum, item) => {
      const id = String(item.productId);
      let discountQty = item.quantity;
      let discountPct = useCompanion ? (companionIds.has(id) ? 10 : 0) : (tierIds.has(id) ? pct : 0);
      if (useCompanion && keepOne && triggerIds.has(id) && item.price === qualifier) { discountQty--; keepOne = false; }
      if ((cart.discount_codes || []).some(x => x.applicable)) discountPct = 0;
      return sum + item.price * item.quantity - Math.round(item.price * discountPct / 100) * discountQty;
    }, 0);
  }
  function offerState() {
    const items = cart.items || [];
    const total = subtotal(items);
    const activeCompanion = Date.now() < config.companionEndsAt;
    const hasNashta = activeCompanion && items.some(item => triggerIds.has(String(item.product_id)));
    const own = title => /^Nashta companion|^Build your basket/.test(title || '');
    let saving = 0;
    for (const item of items) for (const allocation of item.line_level_discount_allocations || []) {
      if (own(allocation.discount_application?.title)) saving += Number(allocation.amount) || 0;
    }
    for (const application of cart.cart_level_discount_applications || []) {
      if (own(application.title)) saving += Number(application.total_allocated_amount) || 0;
    }
    const goal = total < 600000 ? {min: 600000, pct: 5} : total < 1000000 ? {min: 1000000, pct: 10} : total <= 1500000 ? {min: 1500001, pct: 15} : null;
    const hasCode = (cart.discount_codes || []).some(code => code.applicable) || (cart.cart_level_discount_applications || []).some(application => application.type === 'discount_code');
    return {total, saving, hasNashta, activeCompanion, hasCode, count: cart.item_count ?? items.reduce((n, item) => n + item.quantity, 0), tier: tier(total), nextPct: goal?.pct || 0, nextAmount: goal ? Math.max(0, goal.min - total) : 0, progress: Math.min(100, total / 1500001 * 100)};
  }
  function paint() {
    document.querySelectorAll('[data-offer-price]').forEach(render);
    document.dispatchEvent(new CustomEvent('oc:prices-updated', {detail: offerState()}));
  }
  function schedulePaint() { clearTimeout(paintTimer); paintTimer = setTimeout(paint, 0); }
  function selectVariant(node, id, fallbackPrice) {
    const variant = variants.get(String(id));
    node.dataset.offerPrice = id;
    if (variant) { node.dataset.offerProduct = variant.productId; node.dataset.basePrice = variant.price; node.dataset.comparePrice = variant.compareAt; }
    else if (fallbackPrice !== undefined) { node.dataset.basePrice = fallbackPrice; node.dataset.comparePrice = 0; }
    delete node.dataset.offerRendered;
    render(node);
  }
  const baseFetch = window.fetch.bind(window);
  function refresh() {
    if (pending) { revision++; return pending.then(() => refresh()); }
    const started = revision;
    pending = baseFetch(config.root + 'cart.js', {credentials: 'same-origin', cache: 'no-store'})
      .then(r => { if (!r.ok) throw new Error('Cart refresh'); return r.json(); })
      .then(state => { if (started === revision) { cart = state; paint(); } })
      .catch(() => {})
      .finally(() => { pending = null; });
    return pending;
  }
  function scheduleRefresh() { revision++; clearTimeout(refreshTimer); refreshTimer = setTimeout(refresh, 80); }
  window.OCStoreOffers = {refresh, priceFor, selectVariant, paint, quote, state: offerState};
  window.fetch = function(input, init) {
    const request = baseFetch(input, init);
    const url = new URL(input instanceof Request ? input.url : String(input), location.href);
    const method = init?.method || (input instanceof Request ? input.method : 'GET');
    if (url.origin === location.origin && /\/cart\/(add|change|update|clear)(?:\.js)?\/?$/.test(url.pathname) && method.toUpperCase() === 'POST') {
      request.then(response => { if (response.ok) { scheduleRefresh(); try { localStorage.setItem('oc-cart-updated', String(Date.now())); } catch {} } }).catch(() => {});
    }
    return request;
  };
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-oc-card-variant]');
    if (!select) return;
    const card = select.closest('[data-oc-category-card]');
    const price = card?.querySelector('[data-offer-price]');
    const option = select.selectedOptions[0];
    if (price) selectVariant(price, select.value, Number(option.dataset.offerBase));
  });
  document.querySelectorAll('[data-offer-variants]').forEach(node => {
    JSON.parse(node.textContent).forEach(variant => variants.set(String(variant.id), variant));
  });
  paint();
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-offer-price]') || node.querySelector('[data-offer-price]'))))) schedulePaint();
  }).observe(document.body, {childList: true, subtree: true});
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleRefresh);
  window.addEventListener('pageshow', event => { if (event.persisted) scheduleRefresh(); });
  window.addEventListener('focus', scheduleRefresh);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) scheduleRefresh(); });
  window.addEventListener('storage', event => { if (event.key === 'oc-cart-updated') scheduleRefresh(); });
  document.addEventListener('oc:cart-updated', scheduleRefresh);
  refresh();
})();
